<template>
  <Card size="large">
    <View direction="column" gap="md">
      <Text variant="h5">Details</Text>

      <div class="details-grid">
        <template v-for="detail in details" :key="detail.label">
          <Text variant="body-medium" color="tertiary">{{ detail.label }}</Text>
          <Text variant="label-medium" class="detail-value">{{ detail.value }}</Text>
        </template>
      </div>

      <slot />
    </View>
  </Card>
</template>

<script setup lang="ts">
import { Card, Text, View } from '@tallo/design-system';

defineProps<{ details: { label: string; value: string }[] }>();
</script>

<style scoped lang="scss">
.details-grid {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--t-spacing-sm) var(--t-spacing-md);
  align-items: baseline;
}

.detail-value {
  text-align: end;
  word-break: break-word;
}
</style>
